import React, { Component } from 'react';
import getConfig from 'next/config';

// import './startFundraisersPanel.scss';

const config = getConfig().publicRuntimeConfig;

export default class StartFundraisersPanel extends Component {
	render() {
		return (
			<div className="start-fundraiser-banner">
				<div className="sfb-container container">
					<div className="sfb-container-left">
						<div className="sfb-content">
							<strong>Raise funds</strong>
							<br />
							<i>for a cause</i>
							<br />
							<p>
								GiveIndia Fundraisers
								<br />
								is a free platform
							</p>
						</div>
						<a href="https://fundraisers.giveindia.org/start-a-campaign?utm_campaign=RaiseFunds&utm_medium=RaiseFundsBlock&utm_term=&utm_content="
							onClick={() => {
								if (window.eventDispatcher) {
									window.eventDispatcher.dispatchEventSync(
										'start-a-fundraiser-btn',
										{},
										{ amplitude: true }
									);
								}
							}}
						>
							<button className="btn btn-primary">Start a fundraiser</button>
						</a>
					</div>
					<div className="sfb-container-right">
						<img
							src={`${config.cdnUrl}/static/images/home/start-fundraiser-desktop.jpg`}
							alt="Start A Fundraiser"
						/>
					</div>
				</div>
			</div>
		);
	}
}

